module.exports = __webpack_public_path__ + "img/74_top.c07a0939.png";